module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/linkedin-icon-b99c554014d9a0b1d17cd63fb293f3bc.png";